import { createUseQueryHook } from '@iheartjane/react-query-utils';

import { fetchCheckoutRequirements } from './quickCheckout.api';
import type {
  FetchCheckoutRequirementsRequest,
  StoreCheckoutRequirements,
} from './quickCheckout.types';

const quickCheckoutQueryKeys = {
  checkoutRequirements: ({
    storeId,
    reservationMode,
    appMode,
    userId,
  }: Omit<FetchCheckoutRequirementsRequest, 'jwt'>) =>
    [
      'checkoutRequirements',
      storeId,
      reservationMode,
      appMode,
      userId,
    ] as const,
};

export const useCheckoutRequirements = createUseQueryHook<
  FetchCheckoutRequirementsRequest,
  StoreCheckoutRequirements
>(
  fetchCheckoutRequirements,
  quickCheckoutQueryKeys.checkoutRequirements,
  // The endpoint serves anonymous callers, so a jwt is not required — quick
  // checkout callers gate on it themselves via `enabled`.
  ({ storeId }) => !!storeId
);
